import * as types from "../../actions/actionTypes";

const initialModalData = { title: "", message: "" };
const initialState = {
  modalStatus: false,
  modalData: initialModalData
};

const PremiumGuest = (state = initialState, action) => {
  switch (action.type) {
    case types.PREMIUM_GUEST_MODAL_DATA:
      return { ...state, modalStatus: true, modalData: action.data };
    case types.PREMIUM_GUEST_CLOSE_MODAL:
      return { ...state, modalStatus: false, modalData: initialModalData };
    default:
      return state;
  }
};

export default PremiumGuest;
